import { DataTransfersSection } from '../components/data-transfers-section';

const DataTransfersTab = () => (
  <div className="h-full overflow-y-auto p-4 sm:p-6">
    <DataTransfersSection />
  </div>
);

export default DataTransfersTab;
